import { Component, inject } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { StateSnackBarService } from '../../../services/state-snack-bar.service';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatButton,
    MatIcon,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatCardContent,
    RouterLink,
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  private authService = inject(AuthService);
  private snackBar = inject(StateSnackBarService);
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  message: string | null = null;

  requestReset(): void {
    if (this.emailControl.invalid) return;
    const email = this.emailControl.value!;

    this.authService.forgotPassword(email).subscribe((response) => {
      this.message = response.message; // Zeigt die Nachricht vom Backend an
    });
  }
}
